import { render, staticRenderFns } from "./newEstateDetail.vue?vue&type=template&id=f79132f4&scoped=true&"
import script from "./newEstateDetail.vue?vue&type=script&lang=js&"
export * from "./newEstateDetail.vue?vue&type=script&lang=js&"
import style0 from "./newEstateDetail.vue?vue&type=style&index=0&id=f79132f4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f79132f4",
  null
  
)

export default component.exports